module.exports = __webpack_public_path__ + "img/pethouse08.6d82c048.jpg";